/**
 * Filters countComponentDTOList by componentType and returns the flattened data array.
 * @param {Array} countComponentDTOList - The array from projectDetails.countComponentDTOList
 * @param {string} type - The componentType to filter (e.g., "PV", "Battery", "Genset")
 * @returns {Array} - Array of component objects for the given type
 */
export function getComponentsByType(countComponentDTOList, type) {
  if (!Array.isArray(countComponentDTOList)) return [];
  const found = countComponentDTOList.find(
    (item) => item.componentType === type
  );
  return found?.data ?? [];
}
